// Function loadProvenceMapSlider loads the ProvenceMapSlider class by dynamically importing the js on demand if needed

export function loadProvenceMapSlider($parentEl, isList = false) {


	let $wg = $parentEl.querySelector('[data-wg="ProvenceMapSlider"]');

	if(!$wg) {
		// console.info('ProvenceMapSlider: no widget found');
		return Promise.reject('ProvenceMapSlider widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-provence-map-slider-chunk" */ '../widgets/provenceMapSlider').then(wg => {

		const { ProvenceMapSlider } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ProvenceMapSlider"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new ProvenceMapSlider($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ProvenceMapSlider($wg);
		}


	}).catch(error => error+'An error occurred while loading the ProvenceMapSlider widget');

}
